import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import BuildSettings from '../buildSettings';
import globals from './globals';
import { strings, getCurrentLocale } from '../../localization';

export default class Footer extends PureComponent {

    render() {

        var currentYear = new Date().getFullYear();
        const currentLocale = getCurrentLocale();
        return (
            <footer>
                <div className="container">
                    <div className="row footer-navigation">
                        <Link to={'/' + currentLocale + '/dashboard'}>{strings.home}</Link>
                        <a href={globals.supportUrl} target="_blank" alt={strings.support}>{strings.support}</a>
                        <a href={globals.eulaUrl + '#' + currentLocale} target="_blank" alt={strings.eula}>{strings.eula}</a>
                        {globals.ravenHomeUrl ?
                            <a href={globals.ravenHomeUrl} target="_blank" rel="noopener noreferrer">{globals.ravenHome}</a>
                        :
                            null
                        }
                        
                        <p>{strings.formatString(strings.footer_copyright, currentYear)}</p>
                        <p className="build-identification">{BuildSettings.buildId}</p>
                    </div>
                </div>
            </footer>
        );
    }
}
